module.exports = __webpack_public_path__ + "static/img/fp1.5a0246e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fp1.png
// module id = 9DO6
// module chunks = 0